// extracted by mini-css-extract-plugin
export var content = "styles-module--content--4c1c3";
export var ctaContainer = "styles-module--ctaContainer--a2283";
export var green = "styles-module--green--c3e19";
export var pink = "styles-module--pink--4535b";
export var title = "styles-module--title--f6838";
export var white = "styles-module--white--22d58";